import React, { useEffect, useState } from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import {
  fetchMetadata,
  MetadataType,
} from "../../../../service/meta_data/MetaData";
import { LogoImage } from "../../../../widget/common/ui/Logo";
import { useDispatch } from "react-redux";
import { chatResfreshTimeStamp } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { imageExtensions } from "../../../../const/FileExtensions";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";

const BubbleLink: React.FC<ConversationsBubbleType> = ({
  message,
  linkIsMedia = false,
}) => {
  const url: string = message;
  const urls: Array<string> = url.split(".");
  let ext = urls[urls.length - 1];
  ext = ext.toLowerCase();

  const dispatch = useDispatch();

  const [processing, setProcessing] = useState<boolean>(true);
  const [detail, setDetail] = useState<MetadataType | null>(null);

  const getMetaData = async () => {
    setProcessing(true);
    const fetchData: MetadataType | null = await fetchMetadata(url);
    console.log(fetchData);
    if (fetchData != null) {
      setProcessing(false);
      setDetail(fetchData);
      dispatch(chatResfreshTimeStamp());
    }
  };

  useEffect(() => {
    if (!imageExtensions.includes(ext)) {
      getMetaData();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="bubble-link font-gotham-book font-size-15_16 color-black">
      {linkIsMedia ? (
        <>
          {processing ? (
            <>
              {UtilityHelper.isValidURL(url) ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-size-15_16"
                >
                  {url}
                </a>
              ) : (
                <span className="color-blue2">{url}</span>
              )}
            </>
          ) : (
            <div className="bubble-link-media w-100 overflow-hidden">
              <div className="link-image">
                {detail?.image === undefined ? (
                  <span className="opacity-05">
                    <IconNormal
                      name="no_image"
                      size={60}
                      color={AppTheme.grey}
                    />
                  </span>
                ) : (
                  <LogoImage
                    url={detail?.image!}
                    size={`100%`}
                    name={detail?.title!}
                    fixedHieght={false}
                    showErrorImage={true}
                  />
                )}
              </div>
              <div className="link-description">
                <div className="font-gotham-bold ellipsis line-2">
                  {detail?.title!}
                </div>
                <div className="pt-1  ellipsis line-3">
                  {detail?.description!}
                </div>
                {UtilityHelper.isValidURL(url) ? (
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-size-15_16 wrap-all"
                  >
                    {url}
                  </a>
                ) : (
                  <span className="color-blue2">{url}</span>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div>
          {UtilityHelper.isValidURL(url) ? (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="font-size-15_16"
            >
              {url}
            </a>
          ) : (
            <span className="color-blue2">{url}</span>
          )}
          {processing ? (
            <>{/* <Center className="mt-2">{Loader.normal()}</Center> */}</>
          ) : (
            <>
              <div className="pt-2 font-gotham-bold">{detail?.title!}</div>
              <div className="pt-2">{detail?.description!}</div>
              {detail?.image !== undefined && (
                <div className="pt-2 d-center">
                  <LogoImage
                    url={detail?.image!}
                    size={`100%`}
                    name={detail?.title!}
                    fixedHieght={false}
                    showErrorImage={true}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BubbleLink;
